import { FIND_SERVICE } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findService(props: IFindUserInformation) {
  let thisUrl = FIND_SERVICE + "?";
  thisUrl += `page=${props.page ? props.page : 1}`;
  thisUrl += `&limit=${props.limit ? props.limit : 10}`;

  const populateFields =
    "student school parent driver company driver.schoolDriverInformation.superAgent absents financialGroupSchool";

  thisUrl += `&populate=${populateFields}`;
  let body: any = {};

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      [String(props?.search?.base)]: props?.search?.value,
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const {
      superAgent,
      province,
      city,
      student,
      company,
      grade,
      gender,
      parent,
      school,
      driver,
      field,
      statusInService,
      hasFactor,
    } = props.filters;

    body = {
      ...body,
      student: student?.map((item: any) => item?._id),
      superAgent: superAgent?._id,
      company: company?._id,
      school: school?._id,
      parent: parent?._id,
      gender: gender?.value,
      driver: driver,
      city: city?._id,
      province: province?._id,
      grade: grade?._id,
      field: field?._id,
      statusInService: statusInService,
      hasFactor: hasFactor?.value,
      isUnknownDriver: props?.filters?.isUnknownDriver
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ FIND_SERVICE: error });
  }
}

export default findService;
